/* eslint-disable import/no-anonymous-default-export */
import request, { AxiosResponse } from "axios";
import { kore_url } from "./index";
import { NotesObject } from "context/initialState/Notes";
import axios from "axios";
import saveAs from "file-saver";

export default {
  getList: (token: string, param?: string) => {
    const config = {
      method: "GET",
      url: `${kore_url}/api/v4/notes${param ? param : ""}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };

    return request(config)
      .then((notes: AxiosResponse) => {
        return notes.data.items;
      })
      .catch((notesErr) => {
        throw notesErr;
      });
  },
  // TODO: combine these two "Export" functions into one:
  getCSV: (token: string, filter?: string, userEmail?: string) => {
    const queries = () => {
      return filter ? `?filter=${filter}` : "";
    };
    const config = {
      method: "GET",
      url: `${kore_url}/api/v4/notes${queries()}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };

    return request(config)
      .then((notes: AxiosResponse) => {
        return notes.data;
      })
      .catch((notesErr) => {
        throw notesErr;
      });
  },
  getExportPDF: (
    token: string,
    fileName: string,
    filter?: string,
    userEmail?: string
  ) => {
    const queries = () => {
      return filter ? `?filter=${filter}` : "";
    };
    const config = {
      method: "GET",
      url: `${kore_url}/api/v4/notes${queries()}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };

    axios({
      url: config.url,
      headers: config.headers,
      method: "GET",
      responseType: "blob" // Important: This tells axios to expect binary data
    })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        saveAs(blob, `${fileName}.pdf`);
      })
      .catch((error) => {
        // Handle error if necessary
        console.error("Error while downloading PDF:", error);
      });
  },
  getSingle: (id: string, token: string) => {
    const config = {
      method: "GET",
      url: `${kore_url}/api/v4/notes/${id}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };
    return request(config)
      .then((encounters: AxiosResponse) => {
        return encounters;
      })
      .catch((encounterErr) => {
        throw encounterErr;
      });
  },
  create: (note: NotesObject, token: string) => {
    const config = {
      method: "POST",
      url: `${kore_url}/api/v4/notes`,
      data: note,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };
    return request(config)
      .then((encounters: AxiosResponse) => {
        return encounters;
      })
      .catch((encounterErr) => {
        throw encounterErr;
      });
  },
  update: (id: string, note: NotesObject, token: string) => {
    const config = {
      method: "PUT",
      url: `${kore_url}/api/v4/notes/${id}`,
      data: note,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };
    return request(config)
      .then((encounters: AxiosResponse) => {
        return encounters;
      })
      .catch((encounterErr) => {
        throw encounterErr;
      });
  }
};
